import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, X, Check } from "lucide-react";
import { MarketingNav, Footer } from "@/components/MarketingNav";

export default function PercheFarlo() {
  const notYou = [
    "Non devi diventare agente immobiliare",
    "Non devi vendere immobili",
    "Non devi fare visite",
    "Non devi negoziare",
    "Non devi occuparti della documentazione",
  ];
  return (
    <div className="min-h-screen bg-[#0A1128] text-white">
      <MarketingNav />
      <section className="pt-32 pb-16 mx-auto max-w-5xl px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <p className="text-[#D4AF37] text-sm font-medium tracking-wide">PERCHÉ FARLO</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold leading-tight max-w-3xl">
            Trasforma le tue relazioni in opportunità.
          </h1>
          <p className="mt-6 text-white/70 leading-relaxed text-lg max-w-2xl">
            Devi semplicemente metterci in contatto con una possibile opportunità immobiliare.
            Al resto pensiamo noi.
          </p>
        </motion.div>
      </section>
      <section className="pb-16 mx-auto max-w-5xl px-5 sm:px-8 grid md:grid-cols-2 gap-6">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-8">
          <h3 className="font-display text-xl font-medium mb-5">Cosa NON devi fare</h3>
          <ul className="space-y-3">
            {notYou.map((t) => (
              <li key={t} className="flex items-center gap-3 text-white/75">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-rose-500/15 text-rose-400"><X className="h-4 w-4" /></span>
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 p-8">
          <h3 className="font-display text-xl font-medium mb-5">Cosa devi fare</h3>
          <ul className="space-y-3">
            <li className="flex items-center gap-3 text-white/90">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1128]"><Check className="h-4 w-4" /></span>
              Fare una semplice segnalazione
            </li>
            <li className="flex items-center gap-3 text-white/90">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1128]"><Check className="h-4 w-4" /></span>
              Seguire l'avanzamento dalla dashboard
            </li>
            <li className="flex items-center gap-3 text-white/90">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#D4AF37] text-[#0A1128]"><Check className="h-4 w-4" /></span>
              Ricevere il merito fidelizzazione quando maturano le condizioni
            </li>
          </ul>
        </div>
      </section>
      <section className="pb-24 text-center">
        <Link to="/registrati" className="btn-gold inline-flex items-center gap-2 rounded-full px-8 py-4 font-semibold">
          Registrati e segnala <ArrowRight className="h-5 w-5" />
        </Link>
      </section>
      <Footer />
    </div>
  );
}
